import React from 'react'
import NewAppIFrame from 'components/NewAppIFrameViewer';

const ContactRamboll = () => {  
  return (
    <NewAppIFrame
      iFramePagePath={`contact-ramboll`}
      title="Contact Ramboll"
    />
  )

}

export default ContactRamboll